import { useEffect, useState } from "react";
import { BRAND } from "@/content";
import { WhatsAppGlyph, whatsappLink } from "@/components/WhatsApp";
import { Phone } from "lucide-react";

export default function FloatingActions() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-6 start-6 z-40 flex flex-col gap-3 transition-all duration-500 ${
        visible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0 pointer-events-none"
      }`}
      data-testid="floating-actions"
    >
      <a
        href={whatsappLink(null, "floating")}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-2xl hover:scale-110 transition-transform duration-300"
        aria-label="تواصل عبر واتساب"
        data-testid="floating-whatsapp-btn"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <WhatsAppGlyph size={24} />
        <span className="absolute start-full ms-3 bg-brand-ink text-brand-cream text-xs px-3 py-1.5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap" >
          واتساب
        </span>
      </a>
      <a
        href={BRAND.telUrl}
        className="group flex items-center justify-center w-14 h-14 rounded-full bg-brand-olive text-brand-cream shadow-2xl hover:scale-110 transition-transform duration-300"
        aria-label="اتصال هاتفي"
        data-testid="floating-call-btn"
      >
        <Phone size={20} />
        <span className="absolute start-full ms-3 bg-brand-ink text-brand-cream text-xs px-3 py-1.5 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap" >
          اتصل بنا
        </span>
      </a>
    </div>
  );
}

